exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productLocalCustomerFormItem .ant-input[disabled] {\n  color: #000;\n}\n", ""]);

// exports
